function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-d94ba59a\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Button.vue")
}
var Component = require("!../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Button.vue"),
  /* template */
  require("!!../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d94ba59a\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Button.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d94ba59a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/blocks/cards/purchases/components/cancellation/components/button/Button.vue
// module id = da51c1216f68465044d3
// module chunks = 89